/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import React, { Fragment, useMemo } from "react";
import PropTypes from "prop-types";
import { useLocation } from "@reach/router";
import { useStaticQuery, graphql, Script } from "gatsby";
import Helmet from "react-helmet";
// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore/lite";
// import { collectionKeys, getDocDataFilter } from "@core/helper/utils";
// import metaData from '@core/meta.json';

function Seo(props) {
  const {
    title: titleProp,
    metaTitle: metaTitleProp,
    description: descriptionProp,
    image: imageProp,
    noIndex: noIndexProp,
    ogTitle: ogTitleProp,
    ogDescription: ogDescriptionProp,
    ogType: ogTypeProp,
    twitterTitle: twitterTitleProp,
    twitterDescription: twitterDescriptionProp,
    children,
    // siteFirestore,
    schemaMarkup: schemaMarkup,
    slug,
  } = props;

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            keywords
            author
            siteUrl
          }
        }
      }
    `
  );

  // console.log("schemaMarkup", schemaMarkup)

  // const dbMetaData = useMemo(() => {
  //   return metaData.find((item) => item.slug === slug);
  // }, [slug])
  const dbMetaData = null;
  const location = useLocation();

  // const defSiteMetadata = null;
  const defSiteMetadata = site.siteMetadata;
  const currentUrl = location?.href || defSiteMetadata?.siteUrl;

  const titleNew = titleProp;
  const metaTitleNew = titleProp;
  const metaDescriptionNew = dbMetaData?.description || descriptionProp || defSiteMetadata?.description;
  const metaOgTitleNew = dbMetaData?.ogTitle || dbMetaData?.description || ogTitleProp || metaTitleProp || defSiteMetadata?.title;
  const metaOgDescriptionNew = dbMetaData?.description || ogDescriptionProp || descriptionProp || defSiteMetadata?.description;
  const metaOgImageNew = defSiteMetadata?.siteUrl + imageProp;
  const metaOgTypeNew = dbMetaData?.ogType || ogTypeProp || "website";
  const metaTwitterCreatorNew = defSiteMetadata?.author || ``;
  const metaTwitterTitleNew = dbMetaData?.twitterTitle || twitterTitleProp || metaTitleProp || defSiteMetadata?.title;
  const metaTwitterDescNew = dbMetaData?.twitterDescription || twitterDescriptionProp || descriptionProp || defSiteMetadata?.description;
  const metaRobotsNew = `${noIndexProp ? "noindex" : "index"}${", follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"}`;


  return (
    <Fragment>
      <Helmet>

        <title>{titleNew}</title>
        <meta
          name="title"
          content={metaTitleNew}
        />
        <meta
          name="description"
          content={metaDescriptionNew}
        />
        <meta
          property="og:locale"
          content={"en_US"}
        />
        <meta
          property="og:title"
          content={metaOgTitleNew}
        />
        <meta
          property="og:description"
          content={metaOgDescriptionNew}
        />
        <meta
          property="og:image"
          content={metaOgImageNew}
        />
        <meta
          property="og:type"
          content={metaOgTypeNew}
        />
        <meta
          property="og:url"
          content={currentUrl}
        />
        <meta
          name="twitter:card"
          content="summary"
        />
        <meta
          name="twitter:creator"
          content={metaTwitterCreatorNew}
        />
        <meta
          name="twitter:title"
          content={metaTwitterTitleNew}
        />
        <meta
          name="twitter:description"
          content={metaTwitterDescNew}
        />
        <meta
          name="robots"
          content={metaRobotsNew}
        />
        {children}
        {schemaMarkup && <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>}
      </Helmet>
    </Fragment>
  );
}

Seo.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  metaTitle: PropTypes.string,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
  ogType: PropTypes.string,
  twitterTitle: PropTypes.string,
  twitterDescription: PropTypes.string,
  noIndex: PropTypes.bool,
  siteFirestore: PropTypes.object,
  slug: PropTypes.string,
};

export default Seo;
